import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import { useTranslation } from 'react-i18next'

const TableSorting = ({
  sortingOption = null,
  onSortChange
}) => {
  const { t } = useTranslation('TableSorting')
  const sortingOptions = ['alpha', 'newests'].map((key) => (
    { label: t(`options.${key}`), value: key }
  ))

  return (
    <Select
      id="selected-sorting"
      name="selectedSorting"
      onChange={onSortChange}
      options={sortingOptions}
      value={sortingOption}
    />
  )
}

TableSorting.propTypes = {
  sortingOption: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }),
  onSortChange: PropTypes.func.isRequired
}

export default TableSorting
